import React from 'react';
import { Helmet } from "react-helmet";
import '../../styles/project.css'; // Import Project specific CSS
import '../../styles/Fonts.css'; // Import Font specific CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css'; // Import Font Awesome

import bgImage from '../../assets/new/project.webp';
import ProjectServices from './ProjectServices';
import ProjectBenefits from './ProjectBenefits';
import ProjectFAQ from './ProjectFAQ';

const HeroProject = () => {
  return (
    <>
      <Helmet>
        <title>Project Cargo Services | RCS Logistics Philippines</title>
        <meta name="description" content="Professional project cargo services by RCS Logistics Philippines. Expert handling of oversized cargo, special events, and complex logistics projects with precision." />
        <meta name="keywords" content="project cargo services, logistics projects, oversized cargo, special events logistics, RCS Logistics Philippines, professional project cargo, heavy cargo transport, event logistics" />
        <meta property="og:url" content="https://rcslogisticsph.com/project" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Project Cargo Services | RCS Logistics Philippines" />
        <meta property="og:description" content="Professional project cargo services with expert handling of complex logistics projects by RCS Logistics Philippines." />
        <meta property="og:image" content="https://rcslogisticsph.com/project-hero-image.png" />
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:title" content="Project Cargo Services | RCS Logistics Philippines" />
        <meta property="twitter:description" content="Professional project cargo services with expert handling of complex logistics projects by RCS Logistics Philippines." />
        <meta property="twitter:image" content="https://rcslogisticsph.com/project-hero-image.png" />
      </Helmet>

      {/* Hero Section */}
      <section 
        className="project-hero-section" 
        style={{ 
          backgroundImage: `url(${bgImage})`
        }}
      >
        <div className="project-hero-overlay"></div>
        <div className="container hero-content">
          <div className="row">
            <div className="col-lg-10 col-xl-9">
              <div className="text-start">
                <button className="hero-badge" disabled>
                  PROFESSIONAL PROJECT CARGO SERVICES
                </button>
                <h1 className="hero-main-title text-white">
                  Specialized Project Solutions
                </h1>
                <p className="hero-description text-white">
                  Expert logistics for complex projects, oversized cargo, and special events with precision handling and timely delivery.
                </p>
                <div className="hero-actions">
                  <a href="/contactUs" className="btn-primary-hero">Get a Quote</a>
                  <a href="#project-services" className="btn-secondary-hero">Our Services</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Include the other sections */}
      <ProjectServices />
      <ProjectBenefits />
      <ProjectFAQ />
    </>
  );
};

export default HeroProject;
